import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=1b2a8375&"
import script from "./UserForm.vue?vue&type=script&lang=js&"
export * from "./UserForm.vue?vue&type=script&lang=js&"
import style0 from "./UserForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports